<div>
  <form [formGroup]="notificationsForm">
    <section id="section-email-notifications" hlmCard>
      <div hlmCardHeader>
        <h2 hlmCardTitle>E-Mail-Benachrichtigungen</h2>
        <p hlmCardDescription>
          Wir senden Benachrichtigungen an
          <span class="text-foreground font-medium">{{ company?.email }}</span
          >. Die Adresse änderst du unter „Account“.
        </p>
      </div>

      <div hlmCardContent class="space-y-3">
        <div hlmItem variant="outline" class="items-start">
          <div hlmItemContent>
            <span hlmItemTitle>Bei jedem Verkauf benachrichtigen</span>
            <span hlmItemDescription>
              Du erhältst eine E-Mail, sobald ein Gutschein in deinem Shop gekauft wurde – mit
              Gutscheinwert, Code und Käufer. Eine E-Mail pro Bestellung.
            </span>
          </div>
          <div hlmItemActions>
            <hlm-switch
              inputId="notify_on_sale_email"
              aria-label="Bei jedem Verkauf benachrichtigen"
              formControlName="notify_on_sale_email" />
          </div>
        </div>

        <!-- Always-on mails, shown read-only so nobody looks for a switch -->
        <div hlmItem variant="muted" class="items-start">
          <div hlmItemContent>
            <span hlmItemTitle>Sicherheitshinweise</span>
            <span hlmItemDescription>
              Wird die Einlöse-PIN dreimal falsch eingegeben und die öffentliche Einlösung dadurch
              gesperrt, informieren wir dich immer per E-Mail – inklusive Anleitung zum Entsperren.
            </span>
          </div>
          <div hlmItemActions>
            <span hlmBadge variant="secondary">Immer aktiv</span>
          </div>
        </div>
      </div>

      <div hlmCardFooter class="justify-end border-t pt-4">
        <app-save-button
          #saveButton
          size="sm"
          [disabled]="!notificationsForm.valid || !formChanged"
          [loading]="loading"
          (clickEvent)="onSubmit()" />
      </div>
    </section>
  </form>
</div>
